/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_OptionAward_OptionAwardBulkSelectDeselectDto } from '../models/Wealthlane_AwardService_Dtos_OptionAward_OptionAwardBulkSelectDeselectDto';
import type { Wealthlane_AwardService_Dtos_OptionAward_OptionAwardBulkUpdateDto } from '../models/Wealthlane_AwardService_Dtos_OptionAward_OptionAwardBulkUpdateDto';
import type { Wealthlane_AwardService_Dtos_Response_DeleteAwardResponseDto } from '../models/Wealthlane_AwardService_Dtos_Response_DeleteAwardResponseDto';
import type { Wealthlane_AwardService_Dtos_Response_PublishAwardResponseDto } from '../models/Wealthlane_AwardService_Dtos_Response_PublishAwardResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class OptionAwardFilterService {

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Response_PublishAwardResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppOptionAwardFilterPublishOptionAwardByFilter(
requestBody?: Wealthlane_AwardService_Dtos_OptionAward_OptionAwardBulkSelectDeselectDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_PublishAwardResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/option-award-filter/publish-option-award-by-filter',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Response_DeleteAwardResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppOptionAwardFilterBulkDeleteOptionAwardByFilter(
requestBody?: Wealthlane_AwardService_Dtos_OptionAward_OptionAwardBulkSelectDeselectDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_DeleteAwardResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/option-award-filter/bulk-delete-option-award-by-filter',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_OptionAward_OptionAwardBulkUpdateDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppOptionAwardFilterExportOptionAwardByFilter(
requestBody?: Wealthlane_AwardService_Dtos_OptionAward_OptionAwardBulkSelectDeselectDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_OptionAward_OptionAwardBulkUpdateDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/option-award-filter/export-option-award-by-filter',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
